import React from "react"
import * as landingPageStyle from "../landing-page.module.less";
import * as s from "./problems.module.less";
import PaneTitle from "../../pane/pane-title/pane-title";
import Pane from "../../pane/pane";
import ProblemBox from "./box";
import cn from "classnames";

const problemProps = [
	{
		title: "Lange Sales-Zyklen",
		description: "Viele Touchpoints und Entscheider ziehen den Verkauf in die Länge."
	},
	{
		title: "Erklärungsbedürftiges Angebot",
		description: "Interessenten kaufen deine Lösung nur, wenn sie den Mehrwert verstehen."
	},
	{
		title: "Zu wenig Reichweite",
		description: "Wer dich und deine Lösung nicht kennt, wird nicht dein Kunde."
	},
	{
		title: "Begrenzte Kapazitäten",
		description: "Content-Produktion kostet viel Zeit und kommt deshalb zu kurz."
	},
	{
		title: "Hohe Leadkosten",
		description: "Ohne guten Content sind Leadkosten im B2B häufig sehr teuer."
	},
	{
		title: "Abhängig von Empfehlungen",
		description: "Empfehlungen sind nicht planbar und eine Abhängigkeit limitiert Wachstum."
	}
]

const Problems = ({
	problemProps,
	backgroundColor
}) => {
	const heading = "Diese Engpässe bremsen dein Wachstum - in jedem Bereich";
	return (
		<Pane
			bgColor={backgroundColor ?? '#f9f9f9'}
		>
			<div className={cn(landingPageStyle.container, s.container)}>
				<PaneTitle title={heading}/>
				<div className={s.problemWrapper}>
					{problemProps.map(elem => {
						return (
							<ProblemBox
								{...elem}
							/>
						)
					})}
				</div>
			</div>
		</Pane>
	)
}
export default Problems;
